import Slider from 'modules/slider';

window.addEventListener('load', function () {
    const imageSlider = new Slider('.aside');
    const $slider = document.querySelector('.aside');
    const $galleryThumbs = document.querySelectorAll('.product__link');

    $slider.querySelector('.gallery__prev').addEventListener('click', function () { imageSlider.prev(); });
    $slider.querySelector('.gallery__next').addEventListener('click', function () { imageSlider.next(); });

    for (let i = 0; i < $galleryThumbs.length; i++) {
      $galleryThumbs[i].addEventListener('click', e => {
        imageSlider.open();
        imageSlider.goto(e.currentTarget.getAttribute('data-id'));
      });
    }
    
    document.querySelector('.gallery__close').addEventListener('click', e => {
      imageSlider.close();
    });
});


// WEBPACK FOOTER //
// ./schreinerei-gfeller/Frontend/js/app.js